import * as angular from 'angular';

"use strict";
angular.module('UserService', [])
export default 'UserService'
